import { ListItemIcon } from "@material-ui/core";

export default ListItemIcon;
